// userInfo对象包含appKey,token
import * as RongIMLib from '@rongcloud/imlib-next'
export default function init(userInfo,callbacks) {
    if (!userInfo.appKey || !userInfo.token){
        return false;
    }
    console.log(RongIMLib)
    RongIMLib.init({appkey:userInfo.appKey});
    //公有云初始化
    const RongIMClient = RongIMLib
    const Events = RongIMLib.Events



    RongIMLib.connect(userInfo.token).then((res) => {
        
        if (res.code === 0) {
            console.log(res.data.userId)
            localStorage.setItem('ryUserId',res.data.userId)
        }
    })

    /**
     * 正在链接的事件状态
     */
    RongIMLib.addEventListener(Events.CONNECTING, () => {
    console.log('正在链接...')
    })

    /**
     * 链接到服务器会触发这个事件
     */
    RongIMLib.addEventListener(Events.CONNECTED, () => {
    console.log('连接成功')
  
    })
    
    
}
